import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allServices } from 'app/mocks/data/users/services'

import { api } from 'app/utils/constants'

import { Service } from 'app/types/users/service'

export const getService = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.services.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const serviceFound = allServices.find(
            (service) => service.id.toString() === id,
        )

        // Not found
        if (!serviceFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Service>(serviceFound)
    },
)
